import { render } from "./ConfigContractGuide.vue?vue&type=template&id=55c2a282&scoped=true"
import script from "./ConfigContractGuide.vue?vue&type=script&lang=js"
export * from "./ConfigContractGuide.vue?vue&type=script&lang=js"

import "./ConfigContractGuide.vue?vue&type=style&index=0&id=55c2a282&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c2a282"]])

export default __exports__